module.exports = __webpack_public_path__ + "static/media/carousel-3.4dfe3c6b.png";